import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import { toList, CustomType as $CustomType, makeError } from "../gleam.mjs";

class Effect extends $CustomType {
  constructor(x0) {
    super();
    this[0] = x0;
  }
}

export function from(effect) {
  return new Effect(toList([effect]));
}

export function none() {
  return new Effect(toList([]));
}

export function batch(cmds) {
  return new Effect(
    $list.fold(
      cmds,
      toList([]),
      (b, _use1) => {
        if (!(_use1 instanceof Effect)) {
          throw makeError(
            "assignment_no_match",
            "lustre/effect",
            56,
            "",
            "Assignment pattern did not match",
            { value: _use1 }
          )
        }
        let a = _use1[0];
        return $list.append(b, a);
      },
    ),
  );
}

export function map(effect, f) {
  if (!(effect instanceof Effect)) {
    throw makeError(
      "assignment_no_match",
      "lustre/effect",
      62,
      "map",
      "Assignment pattern did not match",
      { value: effect }
    )
  }
  let l = effect[0];
  return new Effect(
    $list.map(
      l,
      (effect) => {
        return (dispatch) => {
          return effect((a) => { return dispatch(f(a)); });
        };
      },
    ),
  );
}
